import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthVerifyService {

  private $isVerified = new BehaviorSubject(false);

  verified() {
    if (!this.$isVerified.value) {
      this.$isVerified.next(true);
    }
  }

  verifiedObs() {
    return this.$isVerified.asObservable();
  }

}
